import { useMutation } from '@tanstack/react-query'
import { getApiClient } from '../../../shared/types/api-client'
import { ExecuteHttpFunctionDto, ExecutionResultDto } from '../types/ExecuteFunctionDto'

interface ExecuteHttpParams {
  appId: string
  functionName: string
  dto: ExecuteHttpFunctionDto
}

interface ExecuteTimerParams {
  appId: string
  functionName: string
}

export function useExecuteHttpFunction() {
  const { mutateAsync, isPending, data, reset } = useMutation({
    mutationFn: async ({ appId, functionName, dto }: ExecuteHttpParams) => {
      const apiClient = getApiClient()
      const response = await apiClient.post(
        `FunctionApps/${encodeURIComponent(appId)}/HttpFunctions/${encodeURIComponent(functionName)}/Execute`,
        dto,
      )
      return response.data as ExecutionResultDto
    },
  })
  return [mutateAsync, isPending, data, reset] as const
}

export function useExecuteTimerFunction() {
  const { mutateAsync, isPending, data, reset } = useMutation({
    mutationFn: async ({ appId, functionName }: ExecuteTimerParams) => {
      const apiClient = getApiClient()
      const response = await apiClient.post(
        `FunctionApps/${encodeURIComponent(appId)}/TimerFunctions/${encodeURIComponent(functionName)}/Execute`,
        {},
      )
      return response.data as ExecutionResultDto
    },
  })
  return [mutateAsync, isPending, data, reset] as const
}
